<template>
  <div class="submission-card is-hidden-touch is-hidden-desktop-only" :class="{ 'is-IE': isIE11 }">
    <div>
      <p class="fair-name" :class="{ 'is-master-project-card': !isSnapshot, 'is-snapshot-project-card': isSnapshot }">
        <a v-if="!isSnapshot & submission.snapshotId > 0"
           :href="`${$webRoot}/project/${submission.snapshotId}`"
           class="fair-link"
           target="_blank">{{ submission.fair.name }}</a>
        <span v-else>{{ submission.fair.name }}</span>
      </p>
    </div>
    <div class="submission-status" :class="`class-${getStatusClass(submission.status).toLowerCase()}`">
      <i class="fa fa-circle" :class="`status-icon-${getStatusClass(submission.status).toLowerCase()}`"></i><span>{{
        getStatus(submission.status)
      }}</span>
    </div>
    <p v-if="ifApproveDeclinePermission">
      <generic-dropdown ref="decisionDropDown"
                        :items="options"
                        :placeholder="'Approve / Decline'"
                        @input="processInput">
      </generic-dropdown>
    </p>
  </div>
</template>

<script>
import userAgent from '@/libs/user-agent'

import GenericDropdown from '@/components/Controls/GenericComponents/dropdown'
import auth from '@/mixins/auth'
import userTypes from '@/mixins/user-types'

export default {
  components: {
    GenericDropdown
  },
  mixins: [auth, userTypes],
  data: function () {
    return {
      options: [
        { name: 'Approve', value: 'STATUS_APPROVED' },
        { name: 'Decline', value: 'STATUS_DECLINED' }
      ]
    }
  },
  props: ['submission', 'isSnapshot'],
  computed: {
    isIE11: function () {
      return userAgent.isIE11()
    },
    isJacAdmin: function () {
      return this.currentUser.type.includes(this.UserTypeJacAdmin)
    },
    isSSDFair: function () {
      return this.submission.fair?.abbreviation === 'SSD'
    },
    currentUser: function () {
      return this.$store.getters.currentUser
    },
    isJudgingAppAdmin: function () {
      return this.currentUser.type.includes(this.UserTypeJudgingAppAdmin)
    },
    canJudgAppAdminApproveOrDecline: function () {
      return this.isJudgingAppAdmin && this.isSSDFair
    },
    canJACApproveDecline: function () {
      return this.isJacAdmin && !this.isSSDFair
    },
    ifApproveDeclinePermission: function () {
      return (this.canJACApproveDecline || this.canJudgAppAdminApproveOrDecline || this.isAdmin) && this.isSnapshot && !this.isApprovedOrDeclined()
    }
  },
  methods: {
    getStatus: function (status) {
      return status.replaceAll('STATUS_', '').replaceAll('_', ' ')
    },
    getStatusClass: function (status) {
      return status.replaceAll('STATUS_', '').replaceAll('_', '-').toLowerCase()
    },
    processInput: function ({ value }) {
      const payload = { status: value, fairId: this.submission.fair.id, abbr: this.submission.fair.abbreviation }
      if (value === 'STATUS_APPROVED') {
        this.$emit('confirmApproval', payload)
      } else {
        this.$emit('reasonDenial', payload)
      }
    },
    isApprovedOrDeclined: function () {
      return this.submission.status === 'STATUS_APPROVED' || this.submission.status === 'STATUS_DECLINED'
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~styles/utils.scss';

::v-deep .floating-label .selected-value {
  top: 33%;
}
.submission-card {
  width: 215px;
  height: fit-content;
  font-size: 0.8rem;
  z-index: 10;
  background-color: white;
  padding: 0.25rem 1rem 0.5rem 1rem;
  color: #4A4A4A;
  margin-bottom: 1rem;

  @media only screen and (max-height: 430px) and (orientation: landscape) {
    background-color: transparent !important;
    margin-top: .25rem;
    margin-left: -1.1rem;
  }

  div {
    margin: 10px 0;
  }

  .fair-name {
    overflow: hidden;
    text-overflow: ellipsis;
    margin: 0 0 1rem 0;
    word-break: break-word !important;
    text-align: center;
    font-weight: bold;
  }

  .fair-link {
    color: black;
  }
}

.submission-status {
  border: 1px solid;
  border-radius: 4px;
  padding: 5px;
  text-align: center;
  font-weight: 500;

  &.class-submitted {
    border-color: rgba(58, 198, 213, 0.2);
    background: rgba(58, 198, 213, 0.2);
  }

  &.class-approved {
    border-color: rgba(40, 188, 0, 0.2);
    background: rgba(40, 188, 0, 0.2);
  }

  &.class-declined {
    border-color: rgba(255, 103, 96, 0.2);
    background: rgba(255, 103, 96, 0.2);
  }
  &.class-not-submitted {
    border-color: rgb(244, 232, 172);
    background: rgb(244, 232, 172);
  }
}

.status-icon-submitted {
  color: #3AC6D5;
  padding-right: 5px;
}

.status-icon-not-submitted {
  color: #f4b80a;
  padding-right: 5px;
}

.status-icon-approved {
  color: #28BC00;
  padding-right: 5px;
}

.status-icon-declined {
  color: #FF6760;
  padding-right: 5px;
}

.is-IE {
  right: calc(100vw / 2 - 400px - 200px - 16px);
}

</style>
